export default function AuthSidePanel({ subtitle }) {
  return (
    <div className="hidden lg:block lg:w-1/2 bg-grey-900 relative overflow-hidden">
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="rounded-full border-4 border-white/60 animate-circle-appear" style={{ width: '378px', height: '378px' }}></div>
        <div className="absolute rounded-full border-4 border-white/60 animate-circle-appear" style={{ width: '336px', height: '336px' }}></div>
        <div className="absolute animate-circle-appear" style={{ top: 'calc(50% - 189px + 8px)', right: 'calc(50% - 189px + 8px)' }}>
          <div className="w-6 h-6 rounded-full border-2 border-white/60 flex items-center justify-center">
            <span className="text-white text-xs font-normal">S</span>
          </div>
        </div>
      </div>

      <div className="absolute inset-0 flex items-center justify-center z-10">
        <div className="text-center">
          <h2 className="text-6xl font-semibold text-white tracking-tight animate-fall-bounce">Sharre Support</h2>
          {subtitle && <p className="text-xl font-semibold text-white/80 mt-4 tracking-wide animate-fall-bounce">{subtitle}</p>}
        </div>
      </div>

      <style>{`
        @keyframes fall-bounce {
          0% { transform: translateY(-100vh); opacity: 0; }
          60% { transform: translateY(0); opacity: 1; }
          75% { transform: translateY(-30px); }
          85% { transform: translateY(0); }
          92% { transform: translateY(-10px); }
          100% { transform: translateY(0); }
        }
        @keyframes circle-appear {
          0% { transform: scale(0); opacity: 0; }
          50% { opacity: 0; }
          70% { transform: scale(1.1); opacity: 1; }
          100% { transform: scale(1); opacity: 1; }
        }
        .animate-fall-bounce { animation: fall-bounce 2s ease-out forwards; }
        .animate-circle-appear { animation: circle-appear 2.5s ease-out forwards; }
      `}</style>
    </div>
  );
}
